import BackLayoutMain from "../components/backLayout/main";

import BackReportList from "../page/back/report";

const routes = [
  {
    path: "back",
    element: <BackLayoutMain />,
    children: [
      {
        path: "report",
        element: <BackReportList />,
      },
      {
        path: "*",
        element: <>無畫面</>,
      },
    ],
  },
];

export default {
  routes,
};
